module.exports = __webpack_public_path__ + "img/Logo-Frankfurt-Rights.efdf95d4.png";